export const PERIOD_OPTIONS = [
	{ value: 'all', label: 'Todos os períodos' },
	{ value: '7d', label: 'Últimos 7 dias' },
	{ value: '15d', label: 'Últimos 15 dias' },
	{ value: '30d', label: 'Últimos 30 dias' },
	{ value: 'custom', label: 'Personalizar' },
] as const;

export const STATUS_OPTIONS = [
	{ value: 'all', label: 'Todas' },
	{ value: 'closed', label: 'Respondidas' },
	{ value: 'open', label: 'Abertas' },
] as const;

export const SORT_OPTIONS = [
	{ value: 'recent', label: 'Mais recentes' },
	{ value: 'oldest', label: 'Mais antigos' },
] as const;
